<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ title }}</b-card-title>
    </b-card-header>

    <b-card-body>
      <line-chart v-if="loaded" :chartdata="chartdata" :options="options" />
    </b-card-body>
  </b-card>
</template>

<script>
import Reports from "@/Apis/Reports";
import LineChart from "./Chart.vue";

export default {
  name: "LineChartContainer",
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: null,
    title: "",
    options: {
      scales: {
        yAxes: [
          {
            display: true,

            ticks: {
              min: 0,
            },
          },
        ],
      },
    },
  }),
  mounted() {},
  methods: {
    async setData(report) {
      this.loaded = false;
      this.title = report.text;
      const res = await new Reports().getReport(report.id);
      let data = this.drawData(res);
      console.log(data);
      let chartdata = {
        labels: data.labels,
        datasets: [
          {
            label: report.text,
            backgroundColor: this.getRandomColor(),
            data: data.reportData,
          },
        ],
      };
      this.chartdata = chartdata;
      this.loaded = true;
    },
    drawData(data) {
      // console.log(data);
      let reportData = [];
      let labels = [];
      for (const [key, value] of Object.entries(data)) {
        reportData.push(value);
        labels.push(key);
      }
      return { reportData, labels };
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>